export const QUANTITY_MOVIES = {
  ON_START: 5,
  BY_BUTTON: 5
};

export const BUTTON = {
  ESCAPE: `Escape`,
  ESC: `Esc`
};

export const MINUTES_IN_HOUR = 60;

export const SHAKE_ANIMATION_TIMEOUT = 600;
export const MILLISECONDS_COUNT = 1000;
